var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#747474",
    d: "M13.089 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#747474",
    d: "M19.983 6.553C17.825 2.236 13.992 0 10.09 0S2.353 2.236.194 6.553a1 1 0 0 0 0 .894C2.353 11.764 6.186 14 10.09 14s7.736-2.236 9.894-6.553a1 1 0 0 0 0-.894M10.09 12c-2.969 0-6.002-1.62-7.87-5 1.868-3.38 4.901-5 7.87-5s6.002 1.62 7.87 5c-1.868 3.38-4.901 5-7.87 5"
  })));
};
export default SvgEyeOpen;